// extracted by mini-css-extract-plugin
module.exports =  {"root":"jya9zvlR9GwEsKVr02_O","prefix":"LyCI0xG19vmeEN0OGc4U","suffix":"i3ANOzX7bN0u43vlNXvo","locked":"lpSykMUbtVOxHCYPWxgI","truncate":"_ypcSWMAfX5xnTWIPPXA"};